@if (!showOtpCheckScreen) {
  <app-registration-form
    [readOnlyMode]="false"
    [isSubmitting]="isBusy"
    (submitRegistration)="onSubmitRegistration($event)"
  ></app-registration-form>

  <app-advertisement-source-client></app-advertisement-source-client>

  @if (requestCodeAuthErrorMessage) {
    <div class="auth-error-message">{{ requestCodeAuthErrorMessage }}</div>
  }

  <div class="row mt-5">
    <div class="col-12 text-center">
      <button
        type="button"
        class="btn btn-blue valider"
        [disabled]="
          registrationFormComponent?.isRegistrationFormValid !== true ||
          advertisementSourceClient?.isMifFormValid !== true ||
          isBusy
        "
        (click)="registrationFormComponent?.onSubmitRegistration()"
      >
        {{ 'Common.Validate' | labelText }}
      </button>
    </div>
  </div>
} @else {
  <app-otp-check (cancel)="onOtpCancel()"></app-otp-check>
}
